const IGNORE_ERROR_CODES = [
  1111, 2017, 1112, 1201, 1202, 1203, 1204, 1205, 3015,
];

function readErrorCode(code: unknown): number | undefined {
  if (typeof code === "number" && Number.isFinite(code)) {
    return code;
  }
  if (typeof code === "string" && code.trim() !== "") {
    const parsed = Number(code);
    return Number.isFinite(parsed) ? parsed : undefined;
  }
  return undefined;
}

/**
 * Deleted-record responses are explained by the Data Lock alert.
 * Do not also raise the global error toast.
 */
export function shouldSuppressGlobalErrorToast(error: {
  response?: {
    status?: number;
    data?: { code?: unknown; message?: unknown };
  };
} | null | undefined): boolean {
  const status = error?.response?.status;
  const code = readErrorCode(error?.response?.data?.code);
  if (code != null && IGNORE_ERROR_CODES.includes(code)) {
    return true;
  }
  return status === 404 || status === 410;
}
